import { useRouter } from 'next/router';
import React from 'react';
import CardOverlay from 'src/components/cards/card-overlay';
import CardV from 'src/components/cards/card-v';
import { APP_IMG } from 'src/constants';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';
function SectionFive({ data }: any) {
  const _data = data?.data;
  const router = useRouter();
  return (
    <SectionWrapper background={`${APP_IMG}/images/hangover/section-background-desktop.png`}>
      <div className='container content'>
        <div className='title-text'>ถอดสูตรวัฒนธรรมการดื่ม สู่ผลลัพธ์ คือ ความเท่าเทียม</div>
        <div className='card-wrapper'>
          <div className='left'>
            <CardOverlay
              data={_data[0]}
              showTitle={true}
              showBlurb={false}
              showByline={false}
              showTime={false}
              external={false}
              //! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_INDEX,
                router: router?.pathname,
                section: 'section-5',
                data: {
                  block: '1',
                  title: _data[0]?.title,
                  heading: 'hang-over-Page',
                  index: '1'
                }
              }}
            />
          </div>
          <div className='right'>
            <CardV
              data={_data[1]}
              showByline={false}
              showTitle={true}
              showBlurb={false}
              showTime={false}
              showCountview={false}
              external={false}
              className=''
              //! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_INDEX,
                router: router?.pathname,
                section: 'section-5',
                data: {
                  title: _data[1]?.title,
                  heading: 'hang-over-Page',
                  index: 1
                }
              }}
            />
            <CardV
              data={_data[2]}
              showByline={false}
              showTitle={true}
              showBlurb={false}
              showTime={false}
              showCountview={false}
              external={false}
              className=''
              //! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_INDEX,
                router: router?.pathname,
                section: 'section-5',
                data: {
                  title: _data[2]?.title,
                  heading: 'hang-over-Page',
                  index: 2
                }
              }}
            />
          </div>
          <a className='view-more' href={`tag/${convertDatasets(data?.dataSet, 'tag-name', true)}`} title={convertDatasets(data?.dataSet, 'tag-name', true)}>
            <p className={'active text-left'}>ดูทั้งหมด</p>
          </a>
        </div>
      </div>
    </SectionWrapper>
  );
}
interface StyledProps {
  background: string;
}
const SectionWrapper = styled.div<StyledProps>`
  position: relative;
  width: 100%;
  margin: auto;
  height: auto;
  padding: 70px 0;
  background-position: center;
  background-image: url(${props => props?.background});
  @media (max-width: 767px) {
    padding: 30px 0;
  }
  .content {
    position: relative;
    @media (max-width: 992px) {
      padding: 0 15px;
    }
    .title-text {
      color: #ea1b3c;
      font-size: 48px;
      font-weight: 900;
      text-align: center;
      width: 100%;
      @media (max-width: 992px) {
        font-size: 28px;
      }
      @media (max-width: 767px) {
        font-size: 24px;
      }
      @media (max-width: 475px) {
        font-size: 18px;
      }
    }
    .card-wrapper {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      margin: 70px 0 40px 0;
      @media (max-width: 767px) {
        flex-direction: column;
        margin: 50px 0 40px 0;
      }
      .view-more {
        position: absolute;
        bottom: -30px;
        right: 0;
        transition: all 0.4s ease-in-out;
        &:hover {
          color: #ed1a3b;
        }
        .text-left {
          font-size: 20px;
          padding: 2px 10px;
          background-color: rgb(220 21 53);
          color: #fff;
          border-radius: 8px;
          white-space: nowrap;
          &:hover {
            color: #ed1a3b;
            background-color: rgb(255, 255, 255);
          }
        }
      }

      .left {
        width: 75%;
        padding: 0 20px;
        .card-overlay {
          margin: 0;
        }
        @media (max-width: 767px) {
          width: 100%;
          padding: 0;
          margin-bottom: 10px;
        }
      }
      .right {
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 20px;
        @media (max-width: 767px) {
          flex-direction: row;
          width: 100%;
          justify-content: space-between;
          gap: 0;
          .card-v {
            width: 48%;
            .title {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
`;
export default SectionFive;
